<template>
  <div>
    <drawer :app="app" />

    <v-container class="mt-1">
      <v-card raised>
        <v-card-title>
          
        </v-card-title>
        <v-card-text>
          <div v-if="this.app.ShowInviteCoApplicant" v-html="$t('labels.AddInviteCoApplicantQuestion')"/>
          <div v-else v-html="$t('labels.AddCoApplicantQuestionNoInvite')"/>
        </v-card-text>
        <v-card-actions class="mb-5 mt-10">
          <v-container>
            <v-row dense>
          <!-- <v-spacer /> -->
           <v-col v-if="this.app.ShowInviteCoApplicant"><v-btn style="width:100%" @click="InviteCoApplicant" color="primary"><v-icon x-small class="mr-2">fas fa-plus</v-icon>{{$t('labels.InviteCoApplicant')}}</v-btn></v-col>
           <v-col v-if="this.app.AddCoApplicant"><v-btn style="width:100%"  @click="addCoApplicant" color="primary"><v-icon x-small class="mr-2">fas fa-plus</v-icon>{{$t('labels.AddCoApplicant')}}</v-btn></v-col>
          <v-col> <v-btn style="width:100%"  @click="next" color="primary">{{$t('labels.NoProceed')}}</v-btn></v-col>
           </v-row>
          </v-container>          
        </v-card-actions>
      </v-card>
    </v-container>

    <div class="loading" v-if="loadFlag">Loading&#8230;</div>
  </div>
</template>

<script>
import drawer from "@/pages/app/agent/user/app/drawer";
import dataSvc from "@/services/dataService";
import localStorageSvc from "@/services/localStorage";
import model from "@/shared/dataModels/app";
export default {
  components: { drawer },
  data() {
    return {
      app: model.appModel(),
      loadFlag: false,
       siteID: this.$route.params.siteid,
      userID: null,
      mortgageApplicationID: this.$route.params.appid
    };
  },
  created() {
    this.userID = localStorageSvc.getUser();
    if (this.userID != "") {
      this.loadPage();
    } else {
      this.$router.push("/" + this.siteID);
    }
  },
  methods: {
      addCoApplicant(){
          let u = "/" + this.siteID + "/user/" + this.mortgageApplicationID + "/addCoApplicant" ;
          this.$router.push(u);
      },
       InviteCoApplicant(){
          let u = "/" + this.siteID + "/user/" + this.mortgageApplicationID + "/coApplicantInvite" ;
          this.$router.push(u);
      },
      next(){
           this.$router.push("/" + this.siteID + "/user/" + this.mortgageApplicationID + "/mortgage");
      },
    loadPage() {
      this.loadFlag = true;
      let postData = {
        SiteID: this.siteID,
        UserID: this.userID,
        MortgageApplicationID: this.mortgageApplicationID
      };
      dataSvc
        .getHttp()
        .post("/api/MTGAPPLoad", postData)
        .then(res => {
          this.loadFlag = false;
          if (res.data.ReturnStatus.ReturnCode == 200) {
            this.app = res.data;
          }
          this.app.UserID = this.userID;
          this.app.SiteID = this.siteID;
        });
    }
  }
};
</script>
